import React from 'react'

import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {SettingsItemType} from "./@type"
import NavigationMenuItemFoldable from "../../menu-items/menu-item-foldable"
import NavigationMenuItemUrl from "../../menu-items/menu-item-url"

type Props = {
    level               : number

    items               : SettingsItemType[]
    navigationSection   : NavigationSection
}

export default function MenuSettings_Items(props: Props) {
    return (
        <>
            {_.map(props.items, (item: SettingsItemType, key: number)=>{
                if (item.subItems) {
                    return (
                        <NavigationMenuItemFoldable
                            key             = {key}
                            name            = {item.name}
                            icon            = {item.icon}
                            expandForUrls   = {_.compact(_.map(item.subItems, 'url'))}
                        >
                            <MenuSettings_Items
                                items               = {item.subItems}
                                level               = {props.level + 1}
                                navigationSection   = {props.navigationSection}
                            />
                        </NavigationMenuItemFoldable>
                    )
                } else {
                    const classes = Classes({
                        'sub-item': props.level > 0
                    })

                    return (
                        <NavigationMenuItemUrl
                            key                 = {key}
                            className           = {classes}
                            level               = {props.level}
                            name                = {item.name}
                            icon                = {item.icon}
                            url                 = {item.url!}
                            exactUrl            = {item.exactUrl}
                            navigationSection   = {props.navigationSection}
                            saveUrl             = {true}
                        />
                    )
                }
            })}
        </>
    )
}

MenuSettings_Items.defaultProps = {
    level: 0
}
